import createHooks from 'zustand';
import createStore from 'zustand/vanilla';
import shallow from 'zustand/shallow';

import { User } from './userEntity';

type UserState = {
  user?: User;
  setUser: (user: User) => void;
};

const store = createStore<UserState>((set) => ({
  user: undefined,
  setUser: (user: User) => {
    set({ user });
  },
}));

const useUserStore = createHooks(store);

const selectorUser = ({ user }: UserState) => {
  return user;
};

const useUser = () => {
  return useUserStore(selectorUser, shallow);
};

export { useUser, useUserStore };
